const testHosts = ['localhost', 'test.runnermaps.nl'];

export const API_URL = 'https://api.dev.runnermaps.nl/rest';
export const API2_URL = testHosts.includes(window.location.hostname)
  ? 'https://test.runnermaps.nl/api'
  : 'https://api.runnermaps.nl/api';
export const STRAVA_CLIENT_ID = 45055;
